import { cn } from "../lib/utils";

/**
 * Skeleton — predictable-shape loading placeholder per UX-DR28. Use this for
 * vault grid, marketplace listings, share-detail page (any surface where the
 * shape of incoming content is known). Spinners for in-progress actions only.
 *
 * Animation respects prefers-reduced-motion automatically (motion-reduce
 * variant of `animate-pulse`).
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded bg-muted motion-reduce:animate-none",
        className
      )}
      {...props}
    />
  );
}
